import { api } from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createProducerCategory = createAsyncThunk(
  "producer-categories/createProducerCategory",
  async ({ token, payload }) => {
    const response = await api.post(
      "/producer-categories",
      { ...payload },
      { token }
    );
    return response.data;
  }
);

export const updateProducerCategory = createAsyncThunk(
  "producer-categories/updateProducerCategory",
  async ({ token, id, payload }) => {
    const response = await api.patch(
      `/producer-categories/${id}`,
      { ...payload },
      { token }
    );
    return response.data;
  }
);

export const deleteProducerCategory = createAsyncThunk(
  "producer-categories/deleteProducerCategory",
  async ({ id, token }) => {
    const response = await api.delete(`/producer-categories/${id}`, { token });
    return response.data;
  }
);

export const getAllProducerCategories = createAsyncThunk(
  "producer-categories/getAllProducerCategories",
  async () => {
    const response = await api.get("/producer-categories");
    return response.data;
  }
);

export const getBasicProducerCategoriesInfo = createAsyncThunk(
  "producer-categories/getBasicProducerCategoriesInfo",
  async ({ token, ...queryParams }) => {
    const response = await api.get(
      "/producer-categories/basic-categories/info",
      {
        token,
        params: queryParams,
      }
    );
    return response.data;
  }
);

export const getProducerCategoryById = createAsyncThunk(
  "producer-categories/getProducerCategoryById",
  async ({ id }) => {
    const response = await api.get(`/producer-categories/${id}`);
    return response.data;
  }
);
